module.exports = __webpack_public_path__ + "img/sigCovid.5912561d.png";